/**
 * Empty, error or "nothing here yet" block.
 *
 * <EmptyState
 *   icon={<PackageOpen />}
 *   title="No projects match"
 *   text="Try a different search or clear the filters."
 *   actions={<button className="pk-btn pk-btn--secondary pk-btn--sm">Clear filters</button>}
 * />
 */
const EmptyState = ({ icon, title, text, actions, role }) => (
  <div className="pk-empty" role={role}>
    {icon && (
      <span className="pk-empty__icon" aria-hidden="true">
        {icon}
      </span>
    )}
    {title && <h2 className="pk-empty__title">{title}</h2>}
    {text && <p className="pk-empty__text">{text}</p>}
    {actions && <div className="pk-empty__actions">{actions}</div>}
  </div>
);

export default EmptyState;
